import Vue from '../main/vue';
import $ from 'jquery';
import router from '../main/vue-routes';
import components from '../algolia';
import {isEmpty, getLangcode, getSpecSheetPath} from '../main/utils';

const loadWellCalculator = () => {
  if (document.querySelector('.slo-wellness--calculator')) {
    new Vue({
      el: '.slo-wellness--calculator',
      comments: true,
      components,
      data() {
        return {
          indexName: this.$algolia.indexPrefix + 'product_variations',
          filterString: '',
          defaultFilterString: 'variation_compliances_certifications:\'WELL Building Standard\' AND variation_discontinued:false',
          facets: ['product_activation', 'product_product_line', 'product_valve', 'variation_type'],
          attributesToRetrieve: [
            'product_title',
            'product_url',
            'product_image',
            'variation_title',
            'variation_sku',
            'variation_image',
            'variation_well_code',
            'variation_well_credits_total'
          ],
          productCategory: null,
          productCategories: [
            {
              'name': 'Flushometers',
              'variation_types': ['Flushometer'],
              'facets': [
                {'id': 'flushometer-activation', 'name': 'product_activation', 'label': 'Flushometer Type'},
                {'id': 'flushometer-valve-type', 'name': 'product_valve', 'label': 'Valve Type'},
                {'id': 'flushometer-product-line', 'name': 'product_product_line', 'label': 'Product Line'}
              ]
            },
            {
              'name': 'Fixtures',
              'variation_types': ['Lavatory', 'Urinal', 'Water Closet'],
              'facets': [
                {'id': 'lavatory-product-type', 'name': 'variation_type', 'label': 'Product Type'}
              ]
            },
            {
              'name': 'Combos',
              'variation_types': ['Closet Combo', 'Faucet/Soap Dispenser Combo', 'Urinal Combo'],
              'facets': [
                {'id': 'combos-product-type', 'name': 'variation_type', 'label': 'Product Type'},
                {'id': 'combos-product-line', 'name': 'product_product_line', 'label': 'Product Line'}
              ]
            },
            {
              'name': 'Faucets',
              'variation_types': ['Faucet'],
              'facets': [{'id': 'faucets-product-line', 'name': 'product_product_line', 'label': 'Product Line'}]
            },
            {
              'name': 'Soap Dispensers',
              'variation_types': ['Soap Dispenser'],
              'facets': [{'id': 'soap-dispenser-product-line', 'name': 'product_product_line', 'label': 'Product Line'}]
            },
            {
              'name': 'Hand Dryers',
              'variation_types': ['Hand Dryer'],
              'facets': false
            }
          ],
          pointsBreakdownIsVisible: false,
          pointsBreakdown: [],
          pointsBreakdownData: [
            {
              'well_credit': 'A',
              'feature': 'W08 - Handwashing',
              'part': 'Part 1 - Provide Bathroom and Handwashing Accommodations',
              'points': '1 point'
            },
            {
              'well_credit': 'B',
              'feature': 'W08 Hygiene Support',
              'part': 'Part 2 - Enhanced Bathroom Accommodations',
              'points': '1 point'
            },
            {
              'well_credit': 'C',
              'feature': 'W08 Hygiene Support',
              'part': 'Part 3 - Support Effective Handwashing',
              'points': '1 point'
            },
            {
              'well_credit': 'D',
              'feature': 'W09 Onsite Non-Potable Water Reuse (Beta)',
              'part': 'Part 1 - Implement Safety Plan for Non-Potable Water Capture and Reuse',
              'points': '1 point'
            },
            {
              'well_credit': 'E',
              'feature': 'X01 Fundamental Material Precautions',
              'part': 'Part 3 - Restrict Lead',
              'points': 'Precondition'
            },
            {
              'well_credit': 'F',
              'feature': 'X07 Material Transparency',
              'part': 'Part 1 - Select Products with Disclosed Ingredients',
              'points': '1 point'
            },
            {
              'well_credit': 'G',
              'feature': 'X07 Material Transparency',
              'part': 'Part 2 - Select Products with Enhanced Ingredient Disclosures',
              'points': '1 point'
            },
            {
              'well_credit': 'H',
              'feature': 'X07 Material Transparency',
              'part': 'Part 3 - Select Products with Third-Party Verified Ingredients',
              'points': '1 point'
            },
            {
              'well_credit': 'I',
              'feature': 'X15 (Beta) Contact Reduction',
              'part': 'Part 2 - Address Surface Hand Touch',
              'points': '1 point'
            }
          ]
        };
      },
      created() {
        this.setCurrentProductCategoryByName('Flushometers');
        document.documentElement.addEventListener('click', this.closePointsBreakdown);
      },
      beforeDestroy() {
        document.documentElement.removeEventListener('click', this.closePointsBreakdown);
      },
      mounted() {
        this.filterString = this.defaultFilterString;

        // $('#product-category-select').selectpicker();
      },
      watch: {
        productCategory: function(newVal) {
          const variationTypesFilterString = newVal.variation_types.map(type => `variation_type:'${type}'`).join(' OR ');

          this.filterString = `${this.defaultFilterString} AND ${variationTypesFilterString}`;
          this.pointsBreakdownIsVisible = false;
        }
      },
      methods: {
        setCurrentProductCategoryByName(name) {
          this.productCategory = this.productCategories.find(cat => cat.name === name);
        },
        pointsBreakdownToggle() {
          this.pointsBreakdownIsVisible = !this.pointsBreakdownIsVisible;
        },
        closePointsBreakdown(event) {
          const $pointBreakdown = $(event.target).closest('.point-breakdown');

          if (!$pointBreakdown.length) {
            $('.point-breakdown').removeClass('active');
            return this.pointsBreakdownIsVisible = false;
          }
        },
        getSpecSheetUrl(item) {
          return getSpecSheetPath(item.variation_sku, getLangcode());
        },
        getPointsBreakdown(hits) {
          const wellCredits = [...new Set(hits.map(hit => Array.isArray(hit.variation_well_code) ? hit.variation_well_code.map(code => code).filter(Boolean) : false).filter(Boolean).flat())];

          return wellCredits.map(wellCredit => this.pointsBreakdownData.find(item => item.well_credit === wellCredit));
        },
        getWellCreditsTotalMax(hits) {
          return Math.max(...hits.map(hit => hit.variation_well_credits_total || 0), 0);
        },
        getFirstImage(hits) {
          const first = hits.find(hit => !isEmpty(hit.product_image));
          return first?.product_image;
        }
      },
      router
    });
  }
};

export default loadWellCalculator;
